import { theme } from "@/constants/themes";

// Resolve color - supports named theme colors (e.g., "complete") or raw values (e.g., "#10b981")
export const resolveColor = (color: string | undefined, colors: theme): string => {
  if (!color) return "transparent";
  const themeColor = colors[color as keyof theme];
  if (themeColor && typeof themeColor === "object" && "border" in themeColor) {
    return themeColor.border;
  }
  return color;
};
